<template>
    <v-container fluid v-if="activeProject">
        <v-card class="mb-3 py-1">
            <v-card-text>
                <div class="title">Bot {{activeProject.bot_name}} - Bot Overview</div>
                <v-layout class="ma-1" align-center wrap>
                    <span class="mr-3">
                    <v-autocomplete
                        v-model="channel"
                        :label="$filters.capitalize($t('channel'))"
                        :items="channelList"
                        clearable
                    ></v-autocomplete>
                </span>
                    
                    <span class="mr-3">
                    <DatePicker
                        v-model="fromDate"
                        :label="$filters.capitalize($t('from'))"
                        :max="toDate"
                    ></DatePicker>
                </span>
                    <span>
                    <DatePicker
                        v-model="toDate"
                        :label="$filters.capitalize($t('to'))"
                        :min="fromDate"
                        :max="today"
                    ></DatePicker>
                </span>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="#878787" dark @click="fetchData" class="text-capitalize">
                        <v-icon class="mr-1">mdi-sync</v-icon>
                        {{$t('update')}}
                    </v-btn>
                    <v-btn depressed color="#42BE80" dark @click="getAgentReportOverviewExcel" class="text-capitalize">
                        <v-icon class="mr-1">mdi-file-excel</v-icon>
                        {{$t('exportReport')}}
                    </v-btn>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-card class="mb-3 pa-3">
            <div class="title mb-3">
                Overall
            </div>
            <TimelineChart :data-sets="ratingBarData" :labels="ratingBarLabels" :is-bot="true"></TimelineChart>
        </v-card>
        <v-layout class="mb-3">
            <v-flex xs6 class="pr-2">
                <v-card class="pa-3">
                    <div class="title">
                        Bot Rating
                    </div>
                    <OverallChartRating
                        :dataSets="ratingBotPieData"
                        :labels="ratingBotPieLabels"
                    ></OverallChartRating>
                </v-card>
            </v-flex>
            <v-flex xs6 class="pl-2">
                <v-card class="pa-3">
                    <div class="title">
                        Bot's Message Reaction
                    </div>
                    <OverallChartRating
                        :data-sets="ratingAnswerPieData"
                        :labels="ratingAnswerPieLabels"
                        :color-reaction="true"
                    ></OverallChartRating>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import DatePicker from '@/components/DatePicker'
import TimelineChart from '@/views/Agent/TimelineChart'
import OverallChartRating from '@/views/Agent/OverallChartRating'
import DataTableMixin from '@/mixins/DataTableMixin'
import AnswerService from '@/services/answer.service'
import BotService from '@/services/bot.service'
import CommonService from '@/services/common.service'
import _ from 'lodash'

export default {
    name: 'BotOverview',
    components: { DatePicker, TimelineChart, OverallChartRating },
    mixins: [DataTableMixin],
    data () {
        return {
            channel: '',
            subChannel: '',
            channelList: this.$const.channelList,
            fromDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            ratingBotPieData: [],
            ratingAnswerPieData: [],
            ratingBotPieLabels: ['1 star  ', '2 stars', '3 stars', '4 stars', '5 stars'],
            ratingAnswerPieLabels: ['Like', 'Dislike'],
            ratingBarLabels: [],
            ratingBarData: []
        }
    },
    computed: {
        ...mapState({
            activeProject: state => state.user.activeProject
        }),
        filter () {
            return {
                channel: this.channel,
                subChannel: this.subChannel,
                fromDate: this.fromDate,
                toDate: this.toDate
            }
        }
    },
    methods: {
        getAgentReportOverviewExcel () {
            return BotService.getBotOverviewReportExcel(this.channel, this.subChannel, this.fromDate, this.toDate)
        },
        getBotReportPieChart () {
            BotService.getBotReportPieChart(this.channel, this.subChannel, this.fromDate, this.toDate).then(
                result => {
                    let _ratingBotPieData = []
                    _.forEach(result.data, function (value, key) {
                        if (key !== 'avg_star' && key !== 'total_rate') {
                            _ratingBotPieData.push(value)
                        }
                    })
                    this.ratingBotPieData = _ratingBotPieData
                })
        },
        getAnswerReportPieChart () {
            AnswerService.getAnswerReportPieChart('bot', this.channel, this.fromDate, this.toDate).then(
                result => {
                    let _ratingAnswerPieData = []
                    _.forEach(result.data, function (value, key) {
                        if (key !== 'total_rate') {
                            _ratingAnswerPieData.push(value)
                        }
                    })
                    this.ratingAnswerPieData = _ratingAnswerPieData
                }
            )
        },
        getOverviewReportBarChart () {
            Promise.all([
                BotService.getBotReportBarChart(this.channel, this.subChannel, this.fromDate, this.toDate),
                AnswerService.getBotAnswerReportBarChart(this.channel, this.fromDate, this.toDate)
            ]).then(
                results => {
                    let answerReportData = results[0].data
                    let agentReportData = results[1].data
                    let dataReport = CommonService.getRateDataChart(agentReportData, answerReportData)
                    this.ratingBarLabels = dataReport.labels
                    this.ratingBarData = dataReport.dataSets
                }
            )
        },
        fetchData () {
            this.getOverviewReportBarChart()
            this.getAnswerReportPieChart()
            this.getBotReportPieChart()
        }
    },
    mounted () {
        // this.fetchData()
    },
    watch: {
        activeProject (val) {
            if (val) {
                this.fetchData()
            }
        },
        filter () {
            this.fetchData()
        },
        '$route': {
            handler () {
                this.fetchData()
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style scoped>

</style>
